export default __webpack_public_path__ + "img/Poppins-Light_5c21009.ttf";